var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"chart-container",style:(`position: relative; height:${_vm.height}; width: 100%`)},[_c('canvas',{attrs:{"id":`linechart-${_vm.id}`}})])
}
var staticRenderFns = []

export { render, staticRenderFns }